// Ionic accordion group value may be a single string or null; open-keys state always works with string arrays.
export const normalizeAccordionValue = (
  value: string | string[] | null | undefined
): string[] => {
  if (Array.isArray(value)) {
    return value.filter((key): key is string => typeof key === 'string');
  }
  return typeof value === 'string' ? [value] : [];
};
